import React, { Component } from "react";
import "./Home.css";
import Navbar from "../Navbar/Navbar";
import Overview from "./Overview/Overview";
import ImpactStats from "./ImpactStats/ImpactStats";
import FeaturedProgrammes from "./FeaturedProgrammes/FeaturedProgrammes";
import VisaHighlightBanner from "./VisaHighlightBanner/VisaHighlightBanner";
import ImageGallery from "./ImageGallery/ImageGallery";
import Slideshow from "./Slideshow/Slideshow";
import Footer from "../Footer/Footer";
import TopContactBar from "../Common/TopContactBar/TopContactBar";
import MainBodyContainer from "../Common/Body/MainBodyContainer/MainBodyContainer";

class Home extends Component {

    render() {
        return (
          <div>
            <TopContactBar />
            <Navbar />
            <div className="index-container">
              <div>
                <Overview />
                <MainBodyContainer>
                  <FeaturedProgrammes />
                  <VisaHighlightBanner />
                </MainBodyContainer>
                <MainBodyContainer>
                  <ImageGallery />
                </MainBodyContainer>
                <MainBodyContainer>
                  <ImpactStats />
                </MainBodyContainer>
                <MainBodyContainer>
                  <Slideshow />
                </MainBodyContainer>
              </div>
            </div>
            <footer>
              <Footer id="footer-section-container" />
            </footer>
          </div>
        );
    }
}

export default Home;